export enum VESTING_TYPE {
  NO_VESTING = 'NO_VESTING',
  TRANCHE = 'TRANCHE',
  CONTINUOUS = 'CONTINUOUS',
}
